export const MODAL_WITH_LEG_PRICES = 1260;
export const MODAL_DRFQ_LEG_PRICES = 1100;
export const MODAL_NO_LEG_PRICES = 1030;

export function quoteModalSize(
  isLegPriceEnabled: boolean,
  isDrfq: boolean,
  multiLegWithOptions?: boolean,
): number {
  if (isLegPriceEnabled) return MODAL_WITH_LEG_PRICES;
  if (isDrfq) return MODAL_DRFQ_LEG_PRICES;
  if (multiLegWithOptions === true) return MODAL_DRFQ_LEG_PRICES;
  return MODAL_NO_LEG_PRICES;
}
